import { Component, OnInit, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSkltnModule, SkltnConfig } from 'ngx-skltn';
import { MatProgressBar } from '@angular/material/progress-bar';

import { Events } from '../services/events.service';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

import { WriteComponent } from '../order/write/write.component';
import { SdayComponent } from '../order/sday/sday.component';
import { EdayComponent } from '../order/eday/eday.component';

import { OviewComponent } from '../order/oview/oview.component';

import * as $ from "jquery";

@Component({
	selector: 'app-order',
	templateUrl: './order.component.html',
	styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {

	pageObj:any = "curr";

	logi_user:any;

	frm : FormGroup;

	startData:any = [];
	endData:any = [];
	changeData:any = [];

	getData:any = [];
	getDataPoint:any = [];
	getDataSday:any = [];
	getDataEday:any = [];

	contractOpen:any;

	orderList:any;

	carKind:any = 1;
	payKind:any = 1;

	priceNum:number = 0;
	oriPriceNum:number = 0;

	showSkltn = false;

	sdayTxt:any = "상차일시 / 예약설정";
	sdayTxt2:any = "";
	edayTxt:any = "하차일시";
	edayTxt2:any = "";

	cargoTxt:any = "화물정보 자동노출";
	shareIn:any = 0;

	autoOrder:any;
	autoProgress:any = 0;

	@ViewChild('cargomemo') memoElement: ElementRef;
	@ViewChild('wname') wnameElement: ElementRef;
	@ViewChild('wphone') wphoneElement: ElementRef;

	constructor(
		private http: HttpClient,
		public dialog: MatDialog,
		public events: Events,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.getData['distance'] = 0;
		this.getData['price'] = 0;
		this.getData['price2'] = 0;
		this.getData['totoal_price'] = 0;
		this.getDataSday['rday'] = "";

		this.getDataPoint['saddrXpoint'] = "";
		this.getDataPoint['saddrYpoint'] = "";
		this.getDataPoint['saddrSido'] = "";
		this.getDataPoint['saddrGugun'] = "";
		this.getDataPoint['saddrDong'] = "";
		this.getDataPoint['eaddrXpoint'] = "";
		this.getDataPoint['eaddrYpoint'] = "";
		this.getDataPoint['eaddrSido'] = "";
		this.getDataPoint['eaddrGugun'] = "";
		this.getDataPoint['eaddrDong'] = "";

		this.frm = new FormGroup({
			carton: new FormControl({
				value: '1t',
				disabled: true
			}),
			cartype: new FormControl({
				value : '',
				disabled: true
			}),
			startWork: new FormControl(''),
			endWork: new FormControl(''),
			price: new FormControl(''),
			memo: new FormControl(''),
			wrname: new FormControl('', Validators.required),
			wrphone: new FormControl('', Validators.required),
			sameinput: new FormControl(''),
		});
	}

	ngOnInit() {
		this.autoOrder = setInterval(() => {
			this.autoProgress = this.autoProgress + 10;
			if( this.autoProgress > 100 )
			{
				this.autoProgress = 0;
				this.getOrderList();
			}
		}, 1000);

		this.getUserData();
	}

	ngDoCheck() {
		this.events.subscribe('user:login', (data: any) => {
			this.getUserData();
		});

		this.events.subscribe('user:logout', (data: any) => {
			this.getUserData();
		});
	}

	ngAfterViewInit() {
		this.getOrderList();
		this.frm.get('price').setValue("0원");
	}

	ngOnDestroy() {
		clearInterval(this.autoOrder);
	}

	async getUserData() {
		this.logi_user = await this.authService.getToken();
		var formData: any = new FormData();
		formData.append("logiUserid", this.logi_user);

		this.http.post(this.env.API_URL + 'api/user.data.php', formData).subscribe((response) => {
			this.contractOpen = response['data']['contract'];

			if( this.contractOpen == 0 ){ this.payKind = 1; }
			else{ this.payKind = 4; }

			this.frm.get('wrname').setValue(response['data']['name']);
			this.frm.get('wrphone').setValue(response['data']['phone']);
		});
	}

	async getOrderList() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/order.list.php', formData).subscribe((response) => {
			this.orderList = response['list'];
		});
	}

	async getOder(idx) {
		const modal = this.dialog.open(OviewComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '1100px',
			disableClose: true,
			data: {
				idx: idx
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['refresh'] == "1" )
				{
				}
			}
		});
	}

	async orderForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);

		//상차지 정보
		if( !this.startData['name'] || !this.startData['tel'] || !this.startData['addr'] )
		{
			this.func.bottomToast("상차지 정보를 등록해주세요.");
			this.openWrite('start');
			return false;
		}

		//하차지 정보
		if( !this.endData['name'] || !this.endData['tel'] || !this.endData['addr'] )
		{
			this.func.bottomToast("하차지 정보를 등록해주세요.");
			this.openWrite('end');
			return false;
		}

		//물품 정보
		if( !this.frm.get('memo').value )
		{
			this.func.bottomToast("물품 정보를 입력해주세요.");
			this.memoElement.nativeElement.focus();
			return false;
		}

		//접수자 정보
		if( !this.frm.get('wrname').value )
		{
			this.func.bottomToast("접수자 이름 또는 상호를 입력해주세요.");
			this.wnameElement.nativeElement.focus();
			return false;
		}

		if( !this.frm.get('wrphone').value )
		{
			this.func.bottomToast("접수자 연락처를 입력해주세요.");
			this.wphoneElement.nativeElement.focus();
			return false;
		}

		formData.append("retype", "logi");
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("wrname", this.frm.get('wrname').value);
		formData.append("wrphone", this.frm.get('wrphone').value);
		formData.append("resname", this.startData['name']);
		formData.append("resphone", this.startData['tel']);
		formData.append("rescom", this.startData['com']);
		formData.append("resdepart", this.startData['depart']);
		formData.append("resaddr", this.startData['addr']);
		formData.append("resaddrroad", this.startData['road']);
		formData.append("resaddrxpoint", this.startData['xpoint']);
		formData.append("resaddrypoint", this.startData['ypoint']);
		formData.append("resaddrsido", this.startData['sido']);
		formData.append("resaddrgugun", this.startData['gugun']);
		formData.append("resaddrdong", this.startData['dong']);
		formData.append("reename", this.endData['name']);
		formData.append("reephone", this.endData['tel']);
		formData.append("reecom", this.endData['com']);
		formData.append("reedepart", this.endData['depart']);
		formData.append("reeaddr", this.endData['addr']);
		formData.append("reeaddrroad", this.endData['road']);
		formData.append("reeaddrxpoint", this.endData['xpoint']);
		formData.append("reeaddrypoint", this.endData['ypoint']);
		formData.append("reeaddrsido", this.endData['sido']);
		formData.append("reeaddrgugun", this.endData['gugun']);
		formData.append("reeaddrdong", this.endData['dong']);

		//차량 정보
		formData.append("recarkind", this.carKind);
		formData.append("recarton", this.frm.get('carton').value);
		formData.append("recartype", this.frm.get('cartype').value);

		//상차시간(구분)
		formData.append("restime", this.getDataSday['type']);

		//상차시간(오전/오후)
		if( this.getDataSday['tchk'] )
		{
			formData.append("restimetype", this.getDataSday['tchk']);
		}

		//상차시간(시)
		formData.append("restimehour", this.getDataSday['thour']);

		//상차시간(분)
		formData.append("restimemin", this.getDataSday['tmin']);

		//예약설정
		formData.append("rereser", this.getDataSday['reser']);

		if( this.getDataSday['rday'] )
		{
			//예약일
			formData.append("rereserday", this.getDataSday['rday']);

			//오전/오후
			formData.append("reresertype", this.getDataSday['rtchk']);

			//예약시간
			formData.append("rereserhour", this.getDataSday['rthour']);

			//예약분
			formData.append("reresermin", this.getDataSday['rtmin']);

			//알림
			formData.append("rereseralarm", this.getDataSday['alarm']);
		}

		//상차방법
		formData.append("reswork", this.frm.get('startWork').value);

		//하차시간(구분)
		formData.append("reetime", this.getDataEday['type']);

		//하차시간(오전/오후)
		if( this.getDataEday['tchk'] )
		{
			formData.append("reetimetype", this.getDataEday['tchk']);
		}

		//하차시간(시)
		formData.append("reetimehour", this.getDataEday['thour']);

		//하차시간(분)
		formData.append("reetimemin", this.getDataEday['tmin']);

		//하차방법
		formData.append("reework", this.frm.get('endWork').value);

		//운송거리
		formData.append("rekm", this.getData['distance']);

		//지급방법
		formData.append("repay", this.payKind);

		//결제금액
		formData.append("repricetotal", this.getData['totoal_price']);
		formData.append("repriceadd", this.priceNum);

		//전달내용
		formData.append("rememo", this.frm.get('memo').value);

		//기본전달내용
		formData.append("rebasictxt", this.cargoTxt);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/order.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
			this.resetForm();
			this.getOrderList();
		});
	}

	//상차지, 하차지 정보 입력 팝업
	async openWrite(type) {
		let name,
				tel,
				com,
				depart,
				addr1,
				addr2,
				road,
				xpoint,
				ypoint,
				sido,
				gugun,
				dong;

		if( type == "start" )
		{
			name = (this.startData['name'])?this.startData['name']:"";
			tel = (this.startData['tel'])?this.startData['tel']:"";
			com = (this.startData['com'])?this.startData['com']:"";
			depart = (this.startData['depart'])?this.startData['depart']:"";
			addr1 = (this.startData['addr1'])?this.startData['addr1']:"";
			addr2 = (this.startData['addr2'])?this.startData['addr2']:"";
			road = (this.startData['road'])?this.startData['road']:"";
			xpoint = (this.startData['xpoint'])?this.startData['xpoint']:"";
			ypoint = (this.startData['ypoint'])?this.startData['ypoint']:"";
			sido = (this.startData['sido'])?this.startData['sido']:"";
			gugun = (this.startData['gugun'])?this.startData['gugun']:"";
			dong = (this.startData['dong'])?this.startData['dong']:"";
		}
		else if( type == "end" )
		{
			name = (this.endData['name'])?this.endData['name']:"";
			tel = (this.endData['tel'])?this.endData['tel']:"";
			com = (this.endData['com'])?this.endData['com']:"";
			depart = (this.endData['depart'])?this.endData['depart']:"";
			addr1 = (this.endData['addr1'])?this.endData['addr1']:"";
			addr2 = (this.endData['addr2'])?this.endData['addr2']:"";
			road = (this.endData['road'])?this.endData['road']:"";
			xpoint = (this.endData['xpoint'])?this.endData['xpoint']:"";
			ypoint = (this.endData['ypoint'])?this.endData['ypoint']:"";
			sido = (this.endData['sido'])?this.endData['sido']:"";
			gugun = (this.endData['gugun'])?this.endData['gugun']:"";
			dong = (this.endData['dong'])?this.endData['dong']:"";
		}

		const modal = this.dialog.open(WriteComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '1100px',
			disableClose: true,
			data: {
				type : type,
				name : name,
				tel : tel,
				com : com,
				depart : depart,
				addr1 : addr1,
				addr2 : addr2,
				road : road,
				xpoint : xpoint,
				ypoint : ypoint,
				sido : sido,
				gugun : gugun,
				dong : dong,
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['type'] == "start" )
				{
					if( dataReturned['data']['name'] )
					{
						this.startData['name'] = dataReturned['data']['name'];
						this.startData['tel'] = dataReturned['data']['tel'];
						this.startData['com'] = (dataReturned['data']['com'])?dataReturned['data']['com']:"-";
						this.startData['depart'] = (dataReturned['data']['depart'])?dataReturned['data']['depart']:"-";
						this.startData['addr'] = dataReturned['data']['addr1']+" "+dataReturned['data']['addr2'];
						this.startData['addr1'] = dataReturned['data']['addr1'];
						this.startData['addr2'] = dataReturned['data']['addr2'];
						this.startData['road'] = dataReturned['data']['road'];
						this.startData['sido'] = dataReturned['data']['sido'];
						this.startData['gugun'] = dataReturned['data']['gugun'];
						this.startData['dong'] = dataReturned['data']['dong'];
						this.startData['xpoint'] = dataReturned['data']['xpoint'];
						this.startData['ypoint'] = dataReturned['data']['ypoint'];
					}
				}
				else if( dataReturned['data']['type'] == "end" )
				{
					if( dataReturned['data']['name'] )
					{
						this.endData['name'] = dataReturned['data']['name'];
						this.endData['tel'] = dataReturned['data']['tel'];
						this.endData['com'] = (dataReturned['data']['com'])?dataReturned['data']['com']:"-";
						this.endData['depart'] = (dataReturned['data']['depart'])?dataReturned['data']['depart']:"-";
						this.endData['addr'] = dataReturned['data']['addr1']+" "+dataReturned['data']['addr2'];
						this.endData['addr1'] = dataReturned['data']['addr1'];
						this.endData['addr2'] = dataReturned['data']['addr2'];
						this.endData['road'] = dataReturned['data']['road'];
						this.endData['sido'] = dataReturned['data']['sido'];
						this.endData['gugun'] = dataReturned['data']['gugun'];
						this.endData['dong'] = dataReturned['data']['dong'];
						this.endData['xpoint'] = dataReturned['data']['xpoint'];
						this.endData['ypoint'] = dataReturned['data']['ypoint'];
					}
				}

				this.changePrice();
			}
		});
	}

	changeCargoInfo() {
		var etc1 = "",
				etc2 = "";

		this.cargoTxt = "";
		this.sdayTxt2 = "";
		this.edayTxt2 = "";

		if( this.getDataSday['type'] == 1 )
		{
			this.sdayTxt2 = "지금상";
		}
		else if( this.getDataSday['type'] == 2 )
		{
			this.sdayTxt2 = "당상("+this.getDataSday['tchk']+" "+this.getDataSday['thour'];

			if( this.getDataSday['tmin'] )
			{
				this.sdayTxt2 += ":"+this.getDataSday['tmin'];
			}

			this.sdayTxt2 += ")";
		}
		else if( this.getDataSday['type'] == 3 )
		{
			this.sdayTxt2 = "예약("+this.getDataSday['rday']+" "+this.getDataSday['rtchk']+" "+this.getDataSday['rthour']+":"+this.getDataSday['rtmin']+")";
			this.getDataEday['type'] = 0;
		}

		if( this.frm.get('startWork').value )
		{
			switch( this.frm.get('startWork').value )
			{
				case "1" : etc1 = "수작업(기사님과 함께)"; break;
				case "2" : etc1 = "수작업(고객님 직접)"; break;
				case "3" : etc1 = "지게차"; break;
			}

			this.sdayTxt2 = this.sdayTxt2+"["+etc1+"]";
		}

		if( this.getDataEday['type'] == 1 )
		{
			this.edayTxt2 = "당착";
		}
		else if( this.getDataEday['type'] == 2 )
		{
			this.edayTxt2 = "낼착("+this.getDataEday['tchk']+" "+this.getDataEday['thour']+":"+this.getDataEday['tmin']+")";
		}
		else
		{
			this.edayTxt2 = "";
		}

		if( this.frm.get('endWork').value )
		{
			switch( this.frm.get('endWork').value )
			{
				case "1" : etc2 = "수작업(기사님과 함께)"; break;
				case "2" : etc2 = "수작업(고객님 직접)"; break;
				case "3" : etc2 = "지게차"; break;
			}

			this.edayTxt2 = this.edayTxt2+"["+etc2+"]";
		}

		this.cargoTxt = this.sdayTxt2+" / "+this.edayTxt2;
	}

	changePos() {
		this.changeData = this.startData;
		this.startData = this.endData;
		this.endData = this.changeData;
	}

	carSel( type ) {
		var a = type - 1;

		$(".car-type li a").removeClass("curr");
		$(".car-type li div").removeClass("curr");
		$(".car-type li:eq("+a+") a").addClass("curr");
		$(".car-type li:eq("+a+") div").addClass("curr");

		if( type == 4 )
		{
			this.frm.get('carton').enable();
			this.frm.get('cartype').enable();
		}
		else
		{
			this.frm.get('carton').disable();
			this.frm.get('cartype').disable();

			this.frm.get('cartype').setValue("");
		}

		this.carKind = type;
		this.frm.get('price').setValue("0원");
		this.changePrice();
	}

	paySel( type ) {
		var a = type - 1;

		if( this.logi_user )
		{
			if( this.contractOpen == 0 )
			{
				if( type == 4 )
				{
					alert("계약 후 이용가능합니다.");
					return false;
				}
			}
		}
		else
		{
			if( type == 4 )
			{
				alert("계약 후 이용가능합니다.");
				return false;
			}
		}

		$(".pay-type li a").removeClass("curr");
		$(".pay-type li a i").removeClass("bi-check-circle-fill").addClass("bi-check-circle");
		$(".pay-type li:eq("+a+") a").addClass("curr");
		$(".pay-type li:eq("+a+") a i").removeClass("bi-check-circle").addClass("bi-check-circle-fill");

		this.payKind = type;
	}

	async changePrice() {
		if( this.startData['addr'] && this.endData['addr'] )
		{
			this.logi_user = await this.authService.getToken();

			//this.func.prcLoading();
			this.showSkltn = true;
			var formData: any = new FormData();
			formData.append("logi_user", this.logi_user);
			formData.append("logi_code", this.env.COM_CODE);

			formData.append("startAddr", this.startData['addr1']);
			formData.append("endAddr", this.endData['addr1']);
			formData.append("carKind", this.carKind);
			formData.append("carTon", this.frm.get('carton').value);
			formData.append("carType", this.frm.get('cartype').value);
			formData.append("startWork", this.frm.get('startWork').value);
			formData.append("endWork", this.frm.get('endWork').value);

			formData.append("saddrXpoint", this.startData['xpoint']);
			formData.append("saddrYpoint", this.startData['ypoint']);
			formData.append("eaddrXpoint", this.endData['xpoint']);
			formData.append("eaddrYpoint", this.endData['ypoint']);

			formData.append("shareIn", this.shareIn);

			this.http.post(this.env.API_URL + 'api/data.km.php', formData).subscribe((response) => {
				this.getData = response['data'];
				this.frm.get('price').setValue(response['data']['plus_price']);
				this.getDataPoint = response['coord'];
				this.priceNum = response['data']['plus_price2'];
				this.oriPriceNum = response['data']['plus_price2'];
				setTimeout(() => {
					this.showSkltn = false;
				}, 700);

				//this.func.closeLoading();
			});
		}
	}

	//상차일시, 예약설정
	async openSday() {
		const sdayModal = this.dialog.open(SdayComponent,{
			panelClass: 'openday-class',
			maxWidth: '400px',
			height: '530px',
			data: {
				'type': this.getDataSday['type'],
				'tchk': this.getDataSday['tchk'],
				'thour': this.getDataSday['thour'],
				'tmin': this.getDataSday['tmin'],
				'rday': this.getDataSday['rday'],
				'rtchk': this.getDataSday['rtchk'],
				'rthour': this.getDataSday['rthour'],
				'rweek': this.getDataSday['rweek'],
				'rtmin': this.getDataSday['rtmin'],
				'alarm': this.getDataSday['alarm'],
				'mod': this.getDataSday['mod'],
				'sidx': this.getDataSday['sidx'],
			},
		});

		sdayModal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['type'] )
				{
					this.getDataSday['type'] = dataReturned['data']['type'];
					if( dataReturned['data']['type'] == 2 )
					{
						this.getDataSday['tchk'] = dataReturned['data']['tchk'];
						this.getDataSday['thour'] = dataReturned['data']['thour'];
						this.getDataSday['tmin'] = dataReturned['data']['tmin'];
					}
					this.getDataSday['reser'] = dataReturned['data']['reser'];
					this.getDataSday['rday'] = dataReturned['data']['rday'];
					this.getDataSday['rweek'] = dataReturned['data']['rweek'];
					this.getDataSday['rtchk'] = dataReturned['data']['rtchk'];
					this.getDataSday['rthour'] = dataReturned['data']['rthour'];
					this.getDataSday['rtmin'] = dataReturned['data']['rtmin'];
					this.getDataSday['alarm'] = dataReturned['data']['alarm'];
					this.getDataSday['sidx'] = dataReturned['data']['sidx'];

					if( dataReturned['data']['reser'] ){ this.getDataSday['mod'] = 1; }else{ this.getDataSday['mod'] = 0; }

					if( dataReturned['data']['type'] == 1 )
					{
						this.sdayTxt = "지금 상차";
						//this.sdayTxt2 = "지금상";
						$(".end-day").removeClass("disabled").attr({"disabled":false});
					}
					else if( dataReturned['data']['type'] == 2 )
					{
						this.sdayTxt = "당일 상차 / "+dataReturned['data']['tchk']+" "+dataReturned['data']['thour']+":"+dataReturned['data']['tmin'];
						//this.sdayTxt2 = "당상("+dataReturned['data']['tchk']+" "+dataReturned['data']['thour']+":"+dataReturned['data']['tmin']+")";
						$(".end-day").removeClass("disabled").attr({"disabled":false});
					}
					else if( dataReturned['data']['type'] == 3 )
					{
						this.sdayTxt = "예약 / "+dataReturned['data']['rday']+" "+dataReturned['data']['rtchk']+" "+dataReturned['data']['rthour']+":"+dataReturned['data']['rtmin'];
						//this.sdayTxt2 = "예약";

						if( dataReturned['data']['alarm'] )
						{
							//this.sdayTxt += "("+dataReturned['data']['alarm']+"분전 알림)";
						}

						$(".end-day").addClass("disabled").attr({"disabled":true});
						this.edayTxt = "하차일시";
					}

					this.changeCargoInfo();
				}
			}
		});
	}


	//하차일시
	async openEday() {
		if( this.getDataSday['reser'] )
		{
			this.func.bottomToast("상차 예약은 하차일시를 선택할 수 없습니다.");
		}
		else
		{
			const edayModal = this.dialog.open(EdayComponent,{
				panelClass: 'openday-class',
				maxWidth: '400px',
				height: '530px',
				data: {
					'type': this.getDataEday['type'],
					'tchk': this.getDataEday['tchk'],
					'thour': this.getDataEday['thour'],
					'tmin': this.getDataEday['tmin']
				}
			});

			edayModal.afterClosed().subscribe(dataReturned => {
				if( dataReturned )
				{
					if( dataReturned['data']['type'] )
					{
						this.getDataEday['type'] = dataReturned['data']['type'];
						this.getDataEday['tchk'] = dataReturned['data']['tchk'];
						this.getDataEday['thour'] = dataReturned['data']['thour'];
						this.getDataEday['tmin'] = dataReturned['data']['tmin'];

						if( dataReturned['data']['type'] == 1 )
						{
							this.edayTxt = "당일 하차";
							//this.edayTxt2 = "당착";
						}
						else if( dataReturned['data']['type'] == 2 )
						{
							this.edayTxt = "내일 하차 / "+dataReturned['data']['tchk']+" "+dataReturned['data']['thour']+":"+dataReturned['data']['tmin'];
							//this.edayTxt2 = "낼착("+dataReturned['data']['tchk']+" "+dataReturned['data']['thour']+":"+dataReturned['data']['tmin']+")";
						}

						this.changeCargoInfo();
					}
				}
			});
		}
	}

	resetForm() {
		this.frm.reset();
		this.startData = [];
		this.endData = [];
		this.getDataSday = [];
		this.getDataEday = [];
		this.cargoTxt = "화물정보 자동노출";
		this.sdayTxt = "상차일시 / 예약설정";
		this.edayTxt = "하차일시";
		this.carSel(1);
		this.paySel(1);
		this.frm.get('carton').setValue('1t');
		this.frm.get('cartype').setValue('');
		this.frm.get('startWork').setValue('');
		this.frm.get('endWork').setValue('');
		this.getData['distance'] = 0;
		this.getData['price'] = 0;
		this.getData['price2'] = 0;
		this.getData['totoal_price'] = 0;
		this.priceNum = 0;
		this.oriPriceNum = 0;
		$(".end-day").removeClass("disabled").attr({"disabled":false});
		this.getUserData();
	}

	minusCal() {
		this.priceNum = this.priceNum - 1000;

		if( this.priceNum >= this.oriPriceNum )
		{

			let priceCal = this.comma(this.priceNum);
			this.frm.get('price').setValue( priceCal+"원" );
		}
		else
		{
			this.priceNum = this.oriPriceNum;
			this.func.bottomToast("최소금액 입니다.");
		}

		this.getData['totoal_price'] = this.comma(parseInt(this.getData['price2']) + this.priceNum);
	}

	plusCal() {
		this.priceNum = this.priceNum + 1000;

		let priceCal = this.comma(this.priceNum);
		this.frm.get('price').setValue( priceCal+"원" );

		this.getData['totoal_price'] = this.comma(parseInt(this.getData['price2']) + this.priceNum);
	}

	comma(num) {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	}

	sameChk(chk:any) {
		if( chk.checked )
		{
			this.frm.get('wrname').setValue(this.startData['name']);
			this.frm.get('wrphone').setValue(this.startData['tel']);
		}
	}

	shareChk(chk:any) {
		if( chk.checked ){ this.shareIn = 1; }
		else{ this.shareIn = 0; }

		this.changePrice();
	}
}
